export default "__VITE_ASSET__d84efed7__"